export enum Launch_Pragmatic {
  "hu" = "hu",
}
